import React, { Component } from 'react';
import { Col, FormGroup, Label, Input } from 'reactstrap';
import { connect } from 'react-redux';
import { addUserChange, addUserCompanyFilter } from '../actions/Users';
import { getCompanies } from '../actions/Companies';
import Toggle from './Toggle';

const userItem = { label: 'User', value: 'user' };
const agentItem = { label: 'Agent', value: 'agent' };
const adminItem = { label: 'Admin', value: 'admin' };
const enterpriseItem = { label: 'Enterprise Admin', value: 'enterpriseAdmin' };
const companyGroupManagerItem = { label: 'CompanyGroupManager', value: 'companyGroupManager' };

const superAdminItems = [
  { label: 'SuperAdmin', value: 'superAdmin' },
  { label: 'QuoteToolAdmin', value: 'quoteToolAdmin' },
  { label: 'CompanyGroupAdmin', value: 'companyGroupAdmin' },
];

const companyGroupAdminItems = [
  { label: 'QuoteToolAdmin', value: 'quoteToolAdmin' },
  { label: 'CompanyGroupAdmin', value: 'companyGroupAdmin' },
];

class AddUserFormForProposals extends Component {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken');

    this.state = {
      selectRole: agentItem,
      dropdownOptions: [],
      selectedCompany: '',
    };
  }

  componentDidMount = async () => {
    const { loggedInUser, getCompanies, setCompanyFilter, agency, companies } = this.props;
    const arr = companies.filter(company => company.name === agency);
    if (loggedInUser.role === 'superAdmin' || loggedInUser.role === 'quoteToolAdmin') {
      await getCompanies(this.token, undefined, 'yes', 'agency');
      const company = {
        name: 'company',
        value: arr[0].name,
        suggestion: { ...arr[0] },
      };
      setCompanyFilter(company);
      this.props.addUserChange({ name: 'role', value: 'agent' });
    }
    this.onAddedUserChange({ target: { value: arr[0]._id, name: 'company' } });
    this.setRoleList(loggedInUser.role, arr[0].companyType);
  };

  setRoleList = (role, companyType) => {
    let dropdownOptions = [];
    if (role === 'superAdmin') {
      dropdownOptions = [
        agentItem,
        adminItem,
        enterpriseItem,
        companyGroupManagerItem,
        ...superAdminItems,
      ];
    } else if (role === 'companyGroupAdmin') {
      dropdownOptions = [
        agentItem,
        adminItem,
        enterpriseItem,
        companyGroupManagerItem,
        ...companyGroupAdminItems,
      ];
    }

    if (role === 'admin' || role === 'enterpriseAdmin') {
      dropdownOptions =
        companyType === 'agency'
          ? [agentItem, adminItem, enterpriseItem]
          : [userItem, adminItem, enterpriseItem];
    } else if (role === 'companyGroupManager') {
      if (this.state.selectedCompany === '') {
        dropdownOptions = [userItem, adminItem, enterpriseItem];
      } else {
        dropdownOptions =
          companyType === 'agency'
            ? [agentItem, adminItem, enterpriseItem]
            : [userItem, adminItem, enterpriseItem];
      }
    }

    this.setState({ dropdownOptions, selectRole: agentItem });
  };

  onAddedUserChange = ev => {
    const { name, value } = ev.target;
    this.props.addUserChange({ name, value: value });
  };

  onEnabledChange = value => {
    this.props.addUserChange({ name: 'enabled', value: !value });
  };

  onRoleSelect = selectedOption => {
    const { value } = selectedOption;
    this.props.addUserChange({ name: 'role', value });
  };

  onCompanyFilter = async company => {
    const { setCompanyFilter, loggedInUser } = this.props;
    setCompanyFilter(company || {});

    if (!company || !company.value) {
      this.onAddedUserChange({ target: { value: null, name: 'company' } });
    } else {
      this.setState({ selectedCompany: company.suggestion }, () => {
        this.setRoleList(loggedInUser.role, company.suggestion.companyType);
      });
      this.onAddedUserChange({ target: { value: company.suggestion._id, name: 'company' } });
    }
  };

  render() {
    const { loggedInUser, companies, companyFilter, agency } = this.props;
    const { selectRole } = this.state;
    return (
      <div className="container">
        <FormGroup row>
          <Label for="name" sm={4}>
            Name
          </Label>
          <Col sm={8}>
            <Input
              required
              type="text"
              name="name"
              value={this.props.name}
              onChange={this.onAddedUserChange}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="email" sm={4}>
            Email
          </Label>
          <Col sm={8}>
            <Input
              autocomplete="off"
              required
              type="email"
              name="email"
              value={this.props.email}
              onChange={this.onAddedUserChange}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="password" sm={4}>
            Password
          </Label>
          <Col sm={8}>
            <Input
              autocomplete="off"
              required
              type="text"
              name="password"
              value={this.props.password}
              onChange={this.onAddedUserChange}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="company" sm={4}>
            Agency
          </Label>
          <Col sm={8}>
            {(loggedInUser.role === 'superAdmin' || loggedInUser.role === 'quoteToolAdmin') &&
            companies ? (
              <Input readOnly value={agency} />
            ) : (
              <Input
                disabled={true}
                type="text"
                name="company"
                value={agency}
                onChange={this.onAddedUserChange}
              />
            )}
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="enabled" sm={4}>
            Status
          </Label>
          <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
            <Toggle
              containerStyle={{ width: '90px' }}
              trackStyle={{ width: '90px' }}
              inactiveLabel="Disabled"
              activeLabel="Enabled"
              value={this.props.enabled}
              thumbAnimateRange={[1, 70]}
              onToggle={this.onEnabledChange}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4}>Role</Label>
          <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
            {selectRole && <Input readOnly value={selectRole.value} />}
          </Col>
        </FormGroup>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.AppState.user,
    loggedInUser: state.AppState.user,
    name: state.UIState.users.addedUser.name,
    email: state.UIState.users.addedUser.email,
    company: state.UIState.users.addedUser.company,
    password: state.UIState.users.addedUser.password,
    enabled: state.UIState.users.addedUser.enabled,
    companies: state.AppState.companies.docs,
    companyFilter: state.UIState.users.companyFilter,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addUserChange: userData => dispatch(addUserChange(userData)),
    setCompanyFilter: filter => dispatch(addUserCompanyFilter(filter)),
    getCompanies: (token, pagination, disablePaginate, type) =>
      dispatch(getCompanies(token, pagination, disablePaginate, type)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddUserFormForProposals);
